<template>
  <div class="page">
    <div class="info">
      <div class="title">{{$route.query.name}}</div>
      <div class="tip">
        <span>已提交人数：{{totalNums}}人</span>
        <div class="btn" @click="showFn()">邀请填写</div>
      </div>
    </div>
    <div class="list" id="pageName">
      <div class="title">名单列表</div>
      <van-empty v-if="noData" description="暂无名单" />
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <div class="top">
          <div class="name">
            {{ item.name }}
          </div>
          <div class="btns">
            <img
              @click="delName(item)"
              src="./assets/name/del.png"
              alt=""
              style="margin-right: 0"
            />
            <!-- <img src="./assets/name/edit.png" alt="" style="margin-right: 0" /> -->
          </div>
        </div>
        <div class="container">
          <div class="con-item">
            <div class="label">证件号码</div>
            <div class="value">{{ item.idCode }}</div>
          </div>
          <div class="con-item">
            <div class="label">出生日期</div>
            <div class="value">
              {{ moment(item.birthday).format("YYYY-MM-DD") }}
            </div>
          </div>
          <div class="con-item">
            <div class="label">手机号</div>
            <div class="value">{{ item.mobile }}</div>
          </div>
          <!-- <div class="con-item">
            <div class="label">备注</div>
            <div class="value">{{ item.remarks }}</div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <van-dialog
      v-model="addFlag"
      title=""
      :closeOnClickOverlay="true"
      :show-confirm-button="false"
    >
      <div class="addbox containerGet" v-show="!qrUrlShow">
        <div class="title">{{ $route.query.name }}</div>
        <div class="erm">
          <img :src="qrUrl" alt="" />
        </div>
        <div class="tip">长按二维码收集名单</div>
      </div>
      <div class="addbox" v-show="qrUrlShow">
        <img style="width: 100%; height: 100%" :src="showUrl" alt="" />
      </div>
    </van-dialog> -->

    <div class="cover" v-show="addFlag" @click.prevent="addFlag = false;">
        <div class="addbox containerGet" v-show="!qrUrlShow" @click.stop="()=>{}">
            <div class="title">{{ $route.query.name }}</div>
            <div class="erm">
            <img :src="qrUrl" alt="" />
            </div>
            <div class="tip">长按二维码收集名单</div>
        </div>
        <div class="addbox" v-show="qrUrlShow" @click.stop="()=>{}">
            <img style="width: 100%; height: 100%" :src="showUrl" alt="" />
        </div>
    </div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog, Field, Checkbox, CheckboxGroup, Button, Toast,Empty } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
import html2canvas from "html2canvas";
var wx = require("weixin-js-sdk");

export default {
  name: "Mine",
  components: {
    Dialog,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Empty.name]:Empty
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
      params: {
        queryKey: "",
        pageNumber: 1,
        pageSize: 200,
      },
      dataList: [],
      totalNums:0,
      form: {},
      addFlag: false,
      qrUrl: "",
      showUrl: "",
      qrUrlShow: false,
      noData: false,
      isLoading: false,

      price: "",
      vxChecked: true,
      baseInfo: {},
      unionId: "",
      openId: "",
    };
  },
  watch: {},
  async mounted() {
    if(this.$page.isInWechat){
      wechatService.auth(
        0,
        ({ openid, unionid }) => {
          if (!!openid && !!unionid) {
            console.log("openId", openid);
            this.unionId = unionid;
            this.openId = openid;
          }
        },
        false
      );
    }
    console.log("this.$route.query",this.$route.query)

    
    let url = `https://x.baojbx.com/nameWrite?id=${this.$route.query.id}&name=${decodeURIComponent(this.$route.query.name)}&accountId=${this.publicData.id}`;
    
    this.qrUrl = "http://yun.huaxiyou.cc/internal.qcode.stream?dstUrl=" + encodeURIComponent(url);
    console.log('url', this.qrUrl)
    await this.getNameList();
    this.$nextTick(() => {
      let page = document.getElementById("pageName"); //绑定在当前组件上
      page.addEventListener("scroll", this.scroll, true);
    });
  },
  beforeDestroy: function () {},
  methods: {
    showFn() {
      this.addFlag = true;
      if(this.showUrl)return
      this.$nextTick(() => {
        setTimeout(() => {
          var dom = $(".containerGet");
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          html2canvas(dom[0], {
            backgroundColor: null,
            scale: 2,
            dpi: 150,
            removeContainer: true,
            useCORS: true,
            allowTaint: true,
            imageTimeout: 0,
            async: true,
            scrollX: 0, //设置这两个scrollX/Y即可
            scrollY: 0,
          }).then((canvas) => {
            let url = canvas.toDataURL();
            this.$nextTick(() => {
              this.showUrl = url;
              console.log(url);
              this.qrUrlShow = true;
            });
          });
        }, 500);
      });
    },
    async getNameList() {
      this.isLoading = true;
      this.params.accountId = this.publicData.id;
      this.params.collectFormId = this.$route.query.id;
      let res = await this.$http.post(
        "/api/collectForm/getNameList",
        this.params
      );
      if (!res.code) {
        console.log("res", res);
        this.totalNums = res.pagination.totalElements
        this.noData = false;
        if (this.params.pageNumber == 1) {
          this.dataList = [];
          if (!res.list.length) {
            this.noData = true;
          }
        }
        this.dataList = [...this.dataList, ...res.list];
      }
      this.isLoading = false;
    },
    scroll() {
      if (this.isLoading) return;
      let page = document.getElementById("pageName");
      if (page.scrollTop + window.innerHeight > page.scrollHeight - 1) {
        this.params.pageNumber++;
        this.getNameList();
      }
    },
    async delName(item) {
      Dialog.confirm({
        title: "提示",
        message: `确定要删除名为“${item.name}”的名单吗？`,
      })
        .then(async () => {
          let res = await this.$http.post("/api/collectForm/deleteName", {
            id: item.id,
            formId: this.$route.query.id,
          });
          if (!res.code && res.t) {
            this.$toast("删除成功！");
            this.params.pageNumber = 1;
            this.getNameList();
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 0.15rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  .info {
    padding: 0.15rem 0.14rem;
    box-sizing: border-box;
    box-shadow: 0px -4px 6px 0px rgba(0, 26, 17, 0.06),
      0px 4px 6px 0px rgba(0, 26, 17, 0.06);
    border-radius: 0.02rem;
    flex-shrink: 0;
    .title {
      font-size: 0.18rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .tip {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.14rem;
      span {
        font-size: 0.12rem;
        font-family: PingFang;
        font-weight: 500;
        color: #666666;
      }
      .btn {
        background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
        padding: 0.06rem 0.14rem;
        font-size: 0.12rem;
        font-family: PingFang;
        font-weight: bold;
        color: #ffffff;
        width: fit-content;
        // line-height: 1;
        border-radius: 0.01rem;
      }
    }
  }
  .list {
    margin-top: 0.3rem;
    overflow-y: scroll;
    .title {
      font-size: 0.17rem;
      font-family: PingFang;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0.14rem;
    }
    .item {
      border-bottom: 1px solid rgba(221, 221, 221, 0.7);
      margin-top: 0.14rem;
      .top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.2rem;
        .name {
          font-size: 0.15rem;
          font-family: PingFang;
          font-weight: bold;
          color: #333333;
        }
        .btns {
          display: flex;
          img {
            width: 0.16rem;
            height: 0.14rem;
            margin: 0 0.15rem;
          }
        }
      }
      .container {
        .con-item {
          padding-bottom: 0.14rem;
          display: flex;
          justify-content: space-between;
          .label {
            font-size: 0.12rem;
            font-family: PingFang;
            font-weight: 500;
            color: #999999;
          }
          .value {
            font-size: 0.12rem;
            font-family: PingFang;
            font-weight: 500;
            color: #333333;
          }
        }
      }
    }
  }
  .cover{
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100vh;
      background: rgba(0,0,0,0.4);
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .addbox {
    width: 3.46rem;
    height: 3.3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 0.18rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-top: 0.6rem;
    }
    .erm {
      padding: 0.1rem;
      box-sizing: border-box;
      display: flex;
      border: 1px solid rgba(45, 217, 122, 1);
      margin-top: 0.25rem;
      img {
        width: 1.43rem;
        height: 1.43rem;
      }
    }
    .tip {
      font-size: 0.12rem;
      font-family: PingFang;
      font-weight: 500;
      color: #333333;
      margin-top: 0.17rem;
    }
  }
}
</style>